import { createSelector } from 'reselect';

import { STANDARD_CATEGORIES, EXPANDED_CATEGORIES } from 'constants/outfits';

const getIsExpanded = ({ outfit: { isExpanded } }) => isExpanded;
const getQualities = ({ myself: { qualities } }) => qualities;
const getOutfit = ({ outfit }) => outfit;

const inputs = [getQualities, getIsExpanded, getOutfit];

const output = (qualities, isExpanded, outfit) => {
  const slotNames = isExpanded ? EXPANDED_CATEGORIES : STANDARD_CATEGORIES;
  return slotNames
    .map(findQualityForSlotName({ outfit, qualities }))
    .filter(_ => _); // exclude undefined or otherwise falsy qualities
};

export default createSelector(inputs, output);

export function findQualityForSlotName({ outfit, qualities }) {
  return slotName => qualities.find(q => q.id === outfit[slotName]);
}